__turbopack_context__.v({
  "agents": "home-module__7b2M_q__agents",
  "agentsFoot": "home-module__7b2M_q__agentsFoot",
  "allowLine": "home-module__7b2M_q__allowLine",
  "allowList": "home-module__7b2M_q__allowList",
  "anchor": "home-module__7b2M_q__anchor",
  "blockFlash": "home-module__7b2M_q__blockFlash",
  "blockLabel": "home-module__7b2M_q__blockLabel",
  "blockLine": "home-module__7b2M_q__blockLine",
  "blockList": "home-module__7b2M_q__blockList",
  "bodyText": "home-module__7b2M_q__bodyText",
  "boundaryBox": "home-module__7b2M_q__boundaryBox",
  "boundarySvg": "home-module__7b2M_q__boundarySvg",
  "boundaryVisual": "home-module__7b2M_q__boundaryVisual",
  "card": "home-module__7b2M_q__card",
  "cardArrow": "home-module__7b2M_q__cardArrow",
  "cardDot": "home-module__7b2M_q__cardDot",
  "cardEdge": "home-module__7b2M_q__cardEdge",
  "cardGrid": "home-module__7b2M_q__cardGrid",
  "cardLine": "home-module__7b2M_q__cardLine",
  "cardLineCmd": "home-module__7b2M_q__cardLineCmd",
  "cardLineOk": "home-module__7b2M_q__cardLineOk",
  "cardName": "home-module__7b2M_q__cardName",
  "cardRole": "home-module__7b2M_q__cardRole",
  "cardScreen": "home-module__7b2M_q__cardScreen",
  "cardSpot": "home-module__7b2M_q__cardSpot",
  "cardTop": "home-module__7b2M_q__cardTop",
  "cardWrap": "home-module__7b2M_q__cardWrap",
  "caret": "home-module__7b2M_q__caret",
  "caret-blink": "home-module__7b2M_q__caret-blink",
  "chipA": "home-module__7b2M_q__chipA",
  "chipB": "home-module__7b2M_q__chipB",
  "chipC": "home-module__7b2M_q__chipC",
  "closing": "home-module__7b2M_q__closing",
  "closingArt": "home-module__7b2M_q__closingArt",
  "closingCopy": "home-module__7b2M_q__closingCopy",
  "closingImage": "home-module__7b2M_q__closingImage",
  "closingShade": "home-module__7b2M_q__closingShade",
  "closingTitle": "home-module__7b2M_q__closingTitle",
  "codeKw": "home-module__7b2M_q__codeKw",
  "codeScan": "home-module__7b2M_q__codeScan",
  "codeStr": "home-module__7b2M_q__codeStr",
  "codeWall": "home-module__7b2M_q__codeWall",
  "computers": "home-module__7b2M_q__computers",
  "computersCopy": "home-module__7b2M_q__computersCopy",
  "dot-pulse": "home-module__7b2M_q__dot-pulse",
  "eyebrow": "home-module__7b2M_q__eyebrow",
  "eyebrow-pop": "home-module__7b2M_q__eyebrow-pop",
  "faq": "home-module__7b2M_q__faq",
  "faqHead": "home-module__7b2M_q__faqHead",
  "faqItem": "home-module__7b2M_q__faqItem",
  "faqList": "home-module__7b2M_q__faqList",
  "fit": "home-module__7b2M_q__fit",
  "fit-row": "home-module__7b2M_q__fit-row",
  "fit-tick": "home-module__7b2M_q__fit-tick",
  "fitFoot": "home-module__7b2M_q__fitFoot",
  "fitHivra": "home-module__7b2M_q__fitHivra",
  "fitNote": "home-module__7b2M_q__fitNote",
  "fitTable": "home-module__7b2M_q__fitTable",
  "fitVerdict": "home-module__7b2M_q__fitVerdict",
  "fitWord": "home-module__7b2M_q__fitWord",
  "floatChip": "home-module__7b2M_q__floatChip",
  "founder": "home-module__7b2M_q__founder",
  "founderInner": "home-module__7b2M_q__founderInner",
  "founderLines": "home-module__7b2M_q__founderLines",
  "founderMark": "home-module__7b2M_q__founderMark",
  "founderQuote": "home-module__7b2M_q__founderQuote",
  "founderRule": "home-module__7b2M_q__founderRule",
  "founderSign": "home-module__7b2M_q__founderSign",
  "githubCta": "home-module__7b2M_q__githubCta",
  "glow-breathe": "home-module__7b2M_q__glow-breathe",
  "guarantee": "home-module__7b2M_q__guarantee",
  "hero": "home-module__7b2M_q__hero",
  "heroActions": "home-module__7b2M_q__heroActions",
  "heroBackdrop": "home-module__7b2M_q__heroBackdrop",
  "heroCopy": "home-module__7b2M_q__heroCopy",
  "heroEyebrow": "home-module__7b2M_q__heroEyebrow",
  "heroGrid": "home-module__7b2M_q__heroGrid",
  "heroProof": "home-module__7b2M_q__heroProof",
  "heroStat": "home-module__7b2M_q__heroStat",
  "heroSubhead": "home-module__7b2M_q__heroSubhead",
  "heroTail": "home-module__7b2M_q__heroTail",
  "heroTitle": "home-module__7b2M_q__heroTitle",
  "heroWord": "home-module__7b2M_q__heroWord",
  "home": "home-module__7b2M_q__home",
  "how": "home-module__7b2M_q__how",
  "howCable": "home-module__7b2M_q__howCable",
  "howDesk": "home-module__7b2M_q__howDesk",
  "howDeskWin": "home-module__7b2M_q__howDeskWin",
  "howLayer": "home-module__7b2M_q__howLayer",
  "howNote": "home-module__7b2M_q__howNote",
  "howNum": "home-module__7b2M_q__howNum",
  "howOuter": "home-module__7b2M_q__howOuter",
  "howPhone": "home-module__7b2M_q__howPhone",
  "howPhoneHead": "home-module__7b2M_q__howPhoneHead",
  "howPhoneScreen": "home-module__7b2M_q__howPhoneScreen",
  "howRail": "home-module__7b2M_q__howRail",
  "howStack": "home-module__7b2M_q__howStack",
  "howStackStep": "home-module__7b2M_q__howStackStep",
  "howStage": "home-module__7b2M_q__howStage",
  "howStepText": "home-module__7b2M_q__howStepText",
  "howSteps": "home-module__7b2M_q__howSteps",
  "howSticky": "home-module__7b2M_q__howSticky",
  "howStill": "home-module__7b2M_q__howStill",
  "howVisual": "home-module__7b2M_q__howVisual",
  "howWin": "home-module__7b2M_q__howWin",
  "laptop": "home-module__7b2M_q__laptop",
  "laptopBase": "home-module__7b2M_q__laptopBase",
  "laptopLabel": "home-module__7b2M_q__laptopLabel",
  "laptopLid": "home-module__7b2M_q__laptopLid",
  "laptopScreen": "home-module__7b2M_q__laptopScreen",
  "lineEmpty": "home-module__7b2M_q__lineEmpty",
  "lineResult": "home-module__7b2M_q__lineResult",
  "lineTool": "home-module__7b2M_q__lineTool",
  "lineUser": "home-module__7b2M_q__lineUser",
  "lineWorking": "home-module__7b2M_q__lineWorking",
  "logoMark": "home-module__7b2M_q__logoMark",
  "logoStrip": "home-module__7b2M_q__logoStrip",
  "markNo": "home-module__7b2M_q__markNo",
  "markYes": "home-module__7b2M_q__markYes",
  "motionSwitch": "home-module__7b2M_q__motionSwitch",
  "neon-flicker": "home-module__7b2M_q__neon-flicker",
  "neon-hum": "home-module__7b2M_q__neon-hum",
  "neon-strike": "home-module__7b2M_q__neon-strike",
  "noMark": "home-module__7b2M_q__noMark",
  "okMark": "home-module__7b2M_q__okMark",
  "open": "home-module__7b2M_q__open",
  "openActions": "home-module__7b2M_q__openActions",
  "phoneChip": "home-module__7b2M_q__phoneChip",
  "phoneChipRed": "home-module__7b2M_q__phoneChipRed",
  "phoneInput": "home-module__7b2M_q__phoneInput",
  "phoneIsland": "home-module__7b2M_q__phoneIsland",
  "phoneLine": "home-module__7b2M_q__phoneLine",
  "phoneTitle": "home-module__7b2M_q__phoneTitle",
  "previewChips": "home-module__7b2M_q__previewChips",
  "price-orbit": "home-module__7b2M_q__price-orbit",
  "priceBody": "home-module__7b2M_q__priceBody",
  "priceCard": "home-module__7b2M_q__priceCard",
  "priceChip": "home-module__7b2M_q__priceChip",
  "priceCloud": "home-module__7b2M_q__priceCloud",
  "priceFigure": "home-module__7b2M_q__priceFigure",
  "priceFoot": "home-module__7b2M_q__priceFoot",
  "priceGlow": "home-module__7b2M_q__priceGlow",
  "priceGrid": "home-module__7b2M_q__priceGrid",
  "priceMarker": "home-module__7b2M_q__priceMarker",
  "priceMore": "home-module__7b2M_q__priceMore",
  "priceSide": "home-module__7b2M_q__priceSide",
  "priceSize": "home-module__7b2M_q__priceSize",
  "priceTop": "home-module__7b2M_q__priceTop",
  "pricing": "home-module__7b2M_q__pricing",
  "primaryCta": "home-module__7b2M_q__primaryCta",
  "reach": "home-module__7b2M_q__reach",
  "reachAgent": "home-module__7b2M_q__reachAgent",
  "reachAgentHalo": "home-module__7b2M_q__reachAgentHalo",
  "reachAgentLabel": "home-module__7b2M_q__reachAgentLabel",
  "reachBlock": "home-module__7b2M_q__reachBlock",
  "reachBlockB": "home-module__7b2M_q__reachBlockB",
  "reachCaption": "home-module__7b2M_q__reachCaption",
  "reachControls": "home-module__7b2M_q__reachControls",
  "reachHalo": "home-module__7b2M_q__reachHalo",
  "reachItemBox": "home-module__7b2M_q__reachItemBox",
  "reachItemHot": "home-module__7b2M_q__reachItemHot",
  "reachItemLabel": "home-module__7b2M_q__reachItemLabel",
  "reachItemShared": "home-module__7b2M_q__reachItemShared",
  "reachKicker": "home-module__7b2M_q__reachKicker",
  "reachLaptop": "home-module__7b2M_q__reachLaptop",
  "reachLaptopBar": "home-module__7b2M_q__reachLaptopBar",
  "reachLaptopTitle": "home-module__7b2M_q__reachLaptopTitle",
  "reachLine": "home-module__7b2M_q__reachLine",
  "reachLockDot": "home-module__7b2M_q__reachLockDot",
  "reachLockIcon": "home-module__7b2M_q__reachLockIcon",
  "reachNote": "home-module__7b2M_q__reachNote",
  "reachOuter": "home-module__7b2M_q__reachOuter",
  "reachPc": "home-module__7b2M_q__reachPc",
  "reachPcSlot": "home-module__7b2M_q__reachPcSlot",
  "reachPcSlotLabel": "home-module__7b2M_q__reachPcSlotLabel",
  "reachShare": "home-module__7b2M_q__reachShare",
  "reachShareDot": "home-module__7b2M_q__reachShareDot",
  "reachStage": "home-module__7b2M_q__reachStage",
  "reachSvg": "home-module__7b2M_q__reachSvg",
  "reachText": "home-module__7b2M_q__reachText",
  "reachVisual": "home-module__7b2M_q__reachVisual",
  "reachWall": "home-module__7b2M_q__reachWall",
  "reachWallLabel": "home-module__7b2M_q__reachWallLabel",
  "repo": "home-module__7b2M_q__repo",
  "repoCard": "home-module__7b2M_q__repoCard",
  "repoDone": "home-module__7b2M_q__repoDone",
  "repoFiles": "home-module__7b2M_q__repoFiles",
  "repoHead": "home-module__7b2M_q__repoHead",
  "repoLicense": "home-module__7b2M_q__repoLicense",
  "repoPath": "home-module__7b2M_q__repoPath",
  "repoPrompt": "home-module__7b2M_q__repoPrompt",
  "repoPublic": "home-module__7b2M_q__repoPublic",
  "repoTerm": "home-module__7b2M_q__repoTerm",
  "ring": "home-module__7b2M_q__ring",
  "ringOuter": "home-module__7b2M_q__ringOuter",
  "rule-draw": "home-module__7b2M_q__rule-draw",
  "rule-grow": "home-module__7b2M_q__rule-grow",
  "scene": "home-module__7b2M_q__scene",
  "sceneBackdrop": "home-module__7b2M_q__sceneBackdrop",
  "sceneBars": "home-module__7b2M_q__sceneBars",
  "sceneFloor": "home-module__7b2M_q__sceneFloor",
  "sceneGlow": "home-module__7b2M_q__sceneGlow",
  "sceneMeta": "home-module__7b2M_q__sceneMeta",
  "scenePhone": "home-module__7b2M_q__scenePhone",
  "scenePhoneInner": "home-module__7b2M_q__scenePhoneInner",
  "sceneRig": "home-module__7b2M_q__sceneRig",
  "sectionActions": "home-module__7b2M_q__sectionActions",
  "sectionHead": "home-module__7b2M_q__sectionHead",
  "sectionTitle": "home-module__7b2M_q__sectionTitle",
  "shareLine": "home-module__7b2M_q__shareLine",
  "spin": "home-module__7b2M_q__spin",
  "spinner": "home-module__7b2M_q__spinner",
  "srOnly": "home-module__7b2M_q__srOnly",
  "sticky": "home-module__7b2M_q__sticky",
  "stickyCta": "home-module__7b2M_q__stickyCta",
  "stickyNote": "home-module__7b2M_q__stickyNote",
  "sweep": "home-module__7b2M_q__sweep",
  "takeOver": "home-module__7b2M_q__takeOver",
  "tapRing": "home-module__7b2M_q__tapRing",
  "textCta": "home-module__7b2M_q__textCta",
  "tmuxBar": "home-module__7b2M_q__tmuxBar",
  "ubuntuArt": "home-module__7b2M_q__ubuntuArt",
  "ubuntuCard": "home-module__7b2M_q__ubuntuCard",
  "ubuntuCta": "home-module__7b2M_q__ubuntuCta",
  "ubuntuMeta": "home-module__7b2M_q__ubuntuMeta",
  "win": "home-module__7b2M_q__win",
  "winBar": "home-module__7b2M_q__winBar",
  "winBody": "home-module__7b2M_q__winBody",
  "winChip": "home-module__7b2M_q__winChip",
  "winDots": "home-module__7b2M_q__winDots",
  "winHost": "home-module__7b2M_q__winHost",
  "winSweep": "home-module__7b2M_q__winSweep",
});
